export default __webpack_public_path__ + "static/media/beauty_salon.8fb8d0ca.png";